import TypographyContainer from "../../components/uiKits/typography";

const Typography = () => {
  return <TypographyContainer />;
};

export default Typography;
